export default function AccountIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 0.125C7.21115 0.125 5.33333 2.00282 5.33333 4.29167C5.33333 6.58051 7.21115 8.45833 9.5 8.45833C11.7888 8.45833 13.6667 6.58051 13.6667 4.29167C13.6667 2.00282 11.7888 0.125 9.5 0.125ZM9.5 2.20833C10.6629 2.20833 11.5833 3.12874 11.5833 4.29167C11.5833 5.4546 10.6629 6.375 9.5 6.375C8.33707 6.375 7.41667 5.4546 7.41667 4.29167C7.41667 3.12874 8.33707 2.20833 9.5 2.20833ZM9.5 11.5833C7.68234 11.5833 5.5283 12.0102 3.71794 12.7247C2.81276 13.0819 1.99448 13.5063 1.3396 14.0512C0.684724 14.5961 0.125 15.3327 0.125 16.2708V18.875H18.875V17.8333V16.2708C18.875 15.3327 18.3153 14.5961 17.6604 14.0512C17.0055 13.5063 16.1872 13.0819 15.2821 12.7247C13.4717 12.0102 11.3177 11.5833 9.5 11.5833ZM9.5 13.6667C10.973 13.6667 12.9855 14.0562 14.5191 14.6615C15.2859 14.9642 15.9343 15.325 16.3278 15.6523C16.7213 15.9797 16.7917 16.2027 16.7917 16.2708V16.7917H2.20833V16.2708C2.20833 16.2027 2.27874 15.9797 2.6722 15.6523C3.06566 15.325 3.71405 14.9642 4.48088 14.6615C6.01453 14.0562 8.02703 13.6667 9.5 13.6667Z"
        fill="currentColor"
      />
    </svg>
  );
}
